import { QueryClient, type QueryClientConfig } from '@tanstack/react-query'

export function createQueryClient(overrides?: QueryClientConfig) {
	return new QueryClient({
		defaultOptions: {
			queries: {
				refetchOnWindowFocus: false,
				refetchOnReconnect: false,
				refetchOnMount: false,
				staleTime: 1000 * 30,
				gcTime: 1000 * 60 * 5,
				retry: 1,
				...overrides?.defaultOptions?.queries,
			},
		},
	})
}
